export default "__VITE_ASSET__8e04319b__"